import React from "react";
import axios from "axios";
import constant from "../../../constant";
import SearchComp from "../../../components/SearchComp";
import Credentials from "../../../pages/Credentials";
import "./style.scss";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searched_text: "",
      favorite: "",
      isShowMenu: false,
      searchFocus: false,
      isAccount: false,
      isLoading: true
    };
  }
  componentDidMount() {
    this.initialLoadFav();
    this.getSearchedText();

    if (window.innerWidth <= 767) this.hideHeader();
  }

  hideHeader = () => {
    let pathname = this.props.location.pathname.split("/")[1];
    let prevScroll = window.pageYOffset;

    window.onscroll = function() {
      let currentScroll = window.pageYOffset;

      if (prevScroll > 150) {
        let header_top = document.getElementById("header_top").style;

        if (prevScroll > currentScroll) {
          header_top.top = "0";
          if (pathname === "dashboard") {
            document.getElementById("header_tab2").style.top = "60px";
            document.getElementById("dash_footer_tab").style.bottom = "0";
          } else if (pathname === "have-desk") {
            document.getElementById("havedesk_tab").style.top = "60px";
          } else if (pathname === "locations") {
            document.getElementById("search_filter_tab").style.top = "60px";
            document.getElementById("location_pagination").style.bottom = "0";
          }
        } else {
          header_top.top = "-60px";
          if (pathname === "dashboard") {
            document.getElementById("header_tab2").style.top = "-110px";
            document.getElementById("dash_footer_tab").style.bottom = "-50px";
          } else if (pathname === "have-desk") {
            document.getElementById("havedesk_tab").style.top = "-110px";
          } else if (pathname === "locations") {
            document.getElementById("search_filter_tab").style.top = "-110px";
            document.getElementById("location_pagination").style.bottom =
              "-50px";
          }
        }
      }
      prevScroll = currentScroll;
    };
  };

  initialLoadFav = () => {
    let space_id = localStorage.getItem("favorites");
    space_id = space_id ? space_id.replace("[", "") : null;
    space_id = space_id ? space_id.replace("]", "") : null;

    let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));
    let _this = this;

    if (space_id) {
      axios
        .get(`${constant.phpHost}action/favorites.php`, {
          params: {
            todo: "get_fav_spaces",
            space_id: space_id,
            cur_val: O_Auth ? O_Auth.currency : 1
          }
        })
        .then(function(res) {
          if (res.data && res.data.length > 0) {
            _this.setState({
              favorite: res.data.length
            });
          }
        });
    }
  };

  getSearchedText = () => {
    let _this = this;
    let { location } = this.props;

    if (location.pathname.split("/")[1] === "locations") {
      axios
        .get(`${constant.phpHost}action/search.php`, {
          params: {
            todo: "get_searched_text",
            url_text: location.pathname.split("/")[2]
          }
        })
        .then(function(res) {
          _this.setState({
            searched_text: res.data,
            isLoading: false
          });
        });
    } else {
      _this.setState({
        isLoading: false
      });
    }
  };

  handleMenuShow = () => {
    let bodyTag = document.getElementsByTagName("body")[0];
    bodyTag.classList.toggle("isPopup");

    this.setState({
      isShowMenu: !this.state.isShowMenu
    });
  };

  handleSearchFocus = () => {
    let _this = this;
    setTimeout(function() {
      _this.setState({
        searchFocus: !_this.state.searchFocus
      });
    }, 100);
  };

  handleAccount = () => {
    this.setState({
      isAccount: !this.state.isAccount
    });
  };

  logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  render() {
    let { location } = this.props;
    let {
      isShowMenu,
      searchFocus,
      isAccount,
      searched_text,
      isLoading
    } = this.state;

    let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));
    let user_id = O_Auth ? O_Auth.id : "";

    return (
      <div className="header_block">
        {isAccount ? <Credentials isPopup={this.handleAccount} /> : null}
        <header id="header_top">
          <div className={`left ${searchFocus ? "focus" : ""}`}>
            <a href="/">
              <img src="/assets/images/logo-hd-b.png" alt="logo" />
            </a>

            {location.pathname !== "/" && !isLoading ? (
              window.innerWidth <= 767 ? (
                searchFocus ? (
                  <div className="header_search">
                    <SearchComp
                      pathname={location.pathname}
                      searched_text={searched_text}
                    />
                    <i
                      className="fa fa-close search_icon"
                      onClick={this.handleSearchFocus}
                    />
                  </div>
                ) : (
                  <i
                    className="fa fa-search search_icon"
                    onClick={this.handleSearchFocus}
                  />
                )
              ) : (
                <SearchComp
                  pathname={location.pathname}
                  searched_text={searched_text}
                />
              )
            ) : null}
          </div>

          <div className={`right ${searchFocus ? "d-n" : ""}`}>
            <div className="favorites">
              <a href="/spaces/favorites">
                <i id="fav_heart" className="fa fa-heart" />
                {/* value changes in id */}
                <span id="fav_count">{this.state.favorite}</span>
              </a>
            </div>
            <div
              className={`nav-icon ${isShowMenu ? "open" : ""}`}
              onClick={this.handleMenuShow}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className={`nav_menu ${isShowMenu ? "show" : ""}`}>
              <div className={`text_block ${user_id !== "" ? "contact" : ""}`}>
                <a href="/contact">Contact</a>
              </div>
              {user_id === "" ? (
                <div className="text_block">
                  <a className="signin" href="/login">
                    <span>Sign in / Sign up </span>
                    <i className="fa fa-user" />
                  </a>
                </div>
              ) : (
                <div className="text_block user_details">
                  <div className="dp_name">
                    <a href="/dashboard/edit-profile">Hi {O_Auth.name}</a>
                  </div>
                  <img
                    className="profile_img"
                    src={O_Auth.dp}
                    alt={O_Auth.name}
                  />

                  <div className="dropcont">
                    <ul>
                      <li>
                        <a href="/dashboard/edit-profile">
                          <i className="fa fa-cog" aria-hidden="true" />
                          <span>Edit Profile</span>
                        </a>
                      </li>
                      <li>
                        <a href="/dashboard/booking">
                          <i
                            className="fa fa-calendar-check-o"
                            aria-hidden="true"
                          />
                          <span>Bookings</span>
                        </a>
                      </li>
                      <li>
                        <a href="/dashboard/hosting">
                          <i className="fa fa-server" aria-hidden="true" />
                          <span>Hosting</span>
                        </a>
                      </li>
                      <li>
                        <a href="/dashboard/accounts">
                          <i className="fa fa-money" aria-hidden="true" />
                          <span>Accounts</span>
                        </a>
                      </li>
                      <li>
                        <a href="/contact">
                          <i className="fa fa-phone" aria-hidden="true" />
                          <span>Contact</span>
                        </a>
                      </li>
                      <li onClick={this.logout.bind(this)}>
                        <a href="/">
                          <i className="fa fa-sign-out" aria-hidden="true" />
                          <span>Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {user_id === "" ? (
                <div className="text_block">
                  <a
                    href={`/have-desk/add/${Math.floor(
                      100000 + Math.random() * 999999
                    )}`}
                    className="add_listing"
                  >
                    List my space
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </header>
      </div>
    );
  }
}
